import * as React from 'react';
import {connect} from "react-redux";
import {Invoice, InvoiceDescriptor} from "../../models/Invoice";
import {ApplicationState} from "../../store";
import {InvoiceList} from '../components/InvoiceList';
import {ColumnData} from '../../models/ColumnData';
import {AppStore} from "../../desktop";
import {actionInvoiceFetchAll, InvoicesActionTypes} from "../../store/invoices";
import {Button} from "@material-ui/core";
import {Tab, TabTypes} from "../Tab";
import {TabsService} from "../TabsService";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {actionInvoiceDelete, actionDeleteInvoices} from '../../store/invoices/actions';
import {t} from "../../core/localization";
import {Customer} from "../../models/Customer";
import {actionCustomerFetchAll} from "../../store/customers";

export interface InvoicesTabProps {
	invoices: Invoice[]
	customers: Customer[]
	tab: Tab
}

export interface InvoicesTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		invoices: state.invoices.list,
		customers: state.customers.list,
		tab: state.tabs.active
	};
}

class InvoicesTab extends React.Component<InvoicesTabProps, InvoicesTabState> {

	constructor(props: InvoicesTabProps) {
		super(props)
	}

	// componentWillMount() {
	//   }
	//
	// componentWillReceiveProps(nextProps: InvoicesTabProps) {
	// }

	componentDidMount() {
		this.loadData()
	}

	onOpenClick(invoice: Invoice){
		TabsService.createTab(t.Invoice + ': ' + invoice.number, TabTypes.INVOICES_NEW, invoice)
	}

	onCopyClick(invoice: Invoice){
		TabsService.createTab(t.Invoice + ': ' + invoice.number, TabTypes.INVOICES_NEW, { ...invoice, id: null })
	}

	onDeleteClick(invoice: Invoice){
		actionInvoiceDelete(invoice);
	}

	onActionDeleteClick(invoices: Invoice[]){
		actionDeleteInvoices(invoices);
	}

	onNewClick() {
		TabsService.createTab(t.NewInvoice, TabTypes.INVOICES_NEW, new Invoice())
	}

	render(): React.ReactNode {

		const {invoices} = this.props;

		var customersMap = this.props.customers.reduce(function(map: any, obj: any) {
			map[obj.id] = obj.title;
			return map;
		}, {});

		const columns = [
		new ColumnData(t.Number, "number"),
		new ColumnData('Type', "type"),
		new ColumnData(t.Customer, "customerId", customersMap),
		new ColumnData(t.InvoiceDate, "issueDate"),
		new ColumnData(t.Price, "price")
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewInvoice}</Button></div>
				<InvoiceList
					columns={columns}
					items={invoices}
					title={t.Invoices}
					onOpenClick={(invoice: Invoice) => this.onOpenClick(invoice)}
					onCopyClick={(invoice: Invoice) => this.onCopyClick(invoice)}
					onDeleteClick={(invoice: Invoice) => this.onDeleteClick(invoice)}
					onActionDeleteClick={(invoices: Invoice[]) => this.onActionDeleteClick(invoices)}
					tab={this.props.tab}
					descriptor={InvoiceDescriptor}
				/>
			</div>
		);
	}

	private loadData() {
		actionCustomerFetchAll()
		actionInvoiceFetchAll()
		//AppStore.dispatch({type: InvoicesActionTypes.FETCH_ALL_REQUEST})
	}
}

export default connect(mapStateToProps)(InvoicesTab);
